import React from 'react'
import { ReportsTableItem } from '../../styledComponents'
import ReportsTableWrapper from '../common/ReportsTableWrapper'
import ScreenerBreakUpReportTableData from './ScreenerBreakUpReportTableData'

export default function ScreenerBreakUpReport({
  reports,
  metricString = 'preScreenings',
  heading = 'Pre Screenings',
  getCorrectReportDateString,
  screeners,
  loadingScreeners,
}) {
  const columnsNumber = (screeners?.length || 0 * 3) + 5

  return (
    <ReportsTableWrapper heading={heading}>
      <div className="min-width-lg">
        <ReportsTableItem header columns={columnsNumber}>
          <div className="reports-header">Report Date</div>
          <div className="reports-header">{heading}</div>
          <div className="reports-header divider-top">Total Screenings</div>
          {screeners?.map((screener, idx) => (
            <div key={screener?.id} className="reports-header ps-4 fw-normal">
              By {screener?.title || screener?.firstName}
            </div>
          ))}
          <div className="reports-header divider-top ">For new Patients</div>
          {screeners?.map((screener, idx) => (
            <div key={screener?.id} className="reports-header ps-4 fw-normal">
              By {screener?.title || screener?.firstName}
            </div>
          ))}
          <div className="reports-header divider-top">For Existing Patients</div>
          {screeners?.map((screener, idx) => (
            <div key={screener?.id} className="reports-header ps-4 fw-normal">
              By {screener?.title || screener?.firstName}
            </div>
          ))}
        </ReportsTableItem>
        {reports?.map((report, idx) => (
          <ScreenerBreakUpReportTableData
            key={idx}
            fullReport={report}
            metricData={report?.metrics?.[metricString]}
            reportEndTime={report?.reportEndTime}
            reportStartTime={report?.reportStartTime}
            getCorrectReportDateString={getCorrectReportDateString}
            columns={columnsNumber}
            screeners={screeners}
            metricString={metricString}
          />
        ))}
      </div>
    </ReportsTableWrapper>
  )
}
